// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__kPnvD","spin":"styles_spin__1m3JR"};